import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'
import { useColorScheme } from '@tribeplatform/react-ui-kit/ThemeProvider'

export const ColorSchemeSettingsForm = () => {
  const { $t } = useI18n()
  const { deviceColorMode } = useColorScheme()

  const { watch, setValue } = useFormContext()
  const syncColorMode: boolean = watch('syncColorMode')

  useEffect(() => {
    if (syncColorMode) {
      setValue('colorMode', deviceColorMode)
    }
  }, [deviceColorMode, setValue, syncColorMode])

  return (
    <Form.Layout>
      <Form.Checkbox
        name="syncColorMode"
        label={
          <T
            defaultMessage="Sync with OS settings"
            id="Settings.Appearance.SyncWithOS"
          />
        }
        helperText={
          <T
            defaultMessage="Automatically switch between light and dark themes when your system does."
            id="Settings.Appearance.SyncWithOS.Description"
          />
        }
      />

      <Form.RadioGroup
        name="colorMode"
        variant="cards"
        disabled={syncColorMode}
      >
        <RadioGroup.Items>
          <RadioGroup.Item
            value="light"
            title={$t({
              defaultMessage: 'Light',
              id: 'Generics.Light.Brightness',
            })}
            disabled={syncColorMode}
            description={
              syncColorMode && deviceColorMode === 'light'
                ? $t({
                    defaultMessage: 'Chosen automatically by your OS.',
                    id: 'Settings.Appearance.ColorMode.ByOS',
                  })
                : ''
            }
          />
          <RadioGroup.Item
            value="dark"
            title={$t({
              defaultMessage: 'Dark',
              id: 'Generics.Dark',
            })}
            disabled={syncColorMode}
            description={
              syncColorMode && deviceColorMode === 'dark'
                ? $t({
                    defaultMessage: 'Chosen automatically by your OS.',
                    id: 'Settings.Appearance.ColorMode.ByOS',
                  })
                : ''
            }
          />
        </RadioGroup.Items>
      </Form.RadioGroup>
      <Form.Actions>
        <Button type="submit" size="lg">
          <T defaultMessage="Update" id="Generics.Update" />
        </Button>
      </Form.Actions>
    </Form.Layout>
  )
}
